import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Card.scss';

export function Card({ header, children, className }) {
	return (
		<div className={classnames('legacy-card', className)}>
			{!!header && <div className="card-header">{header}</div>}
			<div className="card-block">{children}</div>
		</div>
	);
}

Card.propTypes = {
	header: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default Card;
